import {Keys, StorageService} from '../service/storage.service';
import {UserService} from '../service/user.service';
import {PageMapping} from './PageMapping';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class UserNavigator {
    constructor(private storageService: StorageService, private userService: UserService, private pageMapping: PageMapping,
                private router: Router) {
    }

    public async redirectUserBasedOnLoggedInStatus(): Promise<void> {
        if (this.isUserLoggedIn()) {
            const profileId = this.storageService.getItem(Keys.PROFILE_ID);
            const token = this.storageService.getItem(Keys.TOKEN);

            const lenderAndLoanApplicationStatus = await this.userService.getUserLenderApplicationStatus(profileId, token);
            const loanDetails = lenderAndLoanApplicationStatus['loanDetails'];
            const lenderDetails = lenderAndLoanApplicationStatus['lenderDetails'];

            if (!loanDetails && !lenderDetails) {
                await this.router.navigate(['/borrow']);
                return;
            }

            const url = this.shouldRedirectToLenderPage(loanDetails, lenderDetails) ?
                this.pageMapping.whereShouldTheLenderBe(lenderDetails.lender_status, lenderDetails.lender_application_status) :
                this.pageMapping.whereShouldTheBorrowerBe();

            await this.router.navigate([url]);
        }
    }

    public isUserLoggedIn(): boolean {
        return !!this.storageService.getItem(Keys.TOKEN);
    }

    private isLenderDetailsRecentlyUpdated(lenderDetails: any, loanDetails: any) {
        return new Date(lenderDetails.updatedAt) >= new Date(loanDetails.updatedAt);
    }

    private shouldRedirectToLenderPage(loanDetails, lenderDetails) {
        return !loanDetails || (lenderDetails && this.isLenderDetailsRecentlyUpdated(lenderDetails, loanDetails));
    }
}
